import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  async function handleSubscribe(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const formEl = e.currentTarget;
    const formData = new FormData(formEl);
    const honeypotVal = (formData.get('contact_alt') as string || '').trim();

    if (honeypotVal) {
      setStatus('success');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9f46snrf0c7mtq82v6g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || 'Wystąpił błąd. Spróbuj ponownie.';
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('Wystąpił błąd sieci. Spróbuj ponownie.');
      setStatus('error');
    }

    setTimeout(() => setStatus('idle'), 4000);
  }

  return (
    <footer className="w-full bg-secondary-500 text-foreground-950">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-3 font-heading">Kakobuy Polska Spreadsheet Hub</h3>
            <p className="text-sm text-foreground-800 leading-relaxed">
              {t('footer_description')}
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-3 font-heading">Linki</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-800 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                {t('nav_home')}
              </Link>
              <Link to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik" className="text-sm text-foreground-800 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                {t('nav_article')}
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-800 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap">
                Kakobuy Spreadsheet
              </a>
            </nav>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-3 font-heading">Newsletter</h3>
            <form onSubmit={handleSubscribe} data-readdy-form="">
              <input
                type="text"
                name="contact_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-anti-field"
              />
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Twój email"
                  required
                  className="flex-1 px-4 py-2.5 rounded-lg bg-background-50 border border-background-300/60 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap cursor-pointer px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold transition-all duration-200"
                >
                  Zapisz się
                </button>
              </div>
              {status === 'success' && (
                <p className="text-xs text-accent-600 mt-2">Dziękujemy za zapisanie się!</p>
              )}
              {status === 'error' && (
                <p className="text-xs text-red-500 mt-2">{errorMsg}</p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">{t('footer_rights')}</p>
          <p className="text-xs text-foreground-600 text-center max-w-lg">
            {t('footer_disclaimer_text')}
          </p>
        </div>
      </div>
    </footer>
  );
}